import { useEffect, useState } from "react";

export default function TopToScrollBar() {
  const [topButton, setButton] = useState(false);
  const goToTop = () => {
    document
      .querySelector("body")
      .scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  // listent scroll
  const listenToScrol = () => {
    let heightTohidden = 250;
    const windowScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (windowScroll > heightTohidden) {
      // visible top scroll button
      setButton(true);
    } else {
      // hidden top to buttom scroll
      setButton(false);
    }
  };
  useEffect(() => {
    document.querySelector("body").addEventListener("scroll", listenToScrol);
    return ()=> document.querySelector("body").removeEventListener("scroll", listenToScrol);
  }, []);
  return (
    <>
      {topButton && (
        <div className="scrollTypeStyleTop" onClick={goToTop}>
          <span className="material-symbols-outlined scroll-icone scrollIcone">
            keyboard_double_arrow_up
          </span>
        </div>
      )}
    </>
  );
}
